export default __webpack_public_path__ + "static/media/0303.ed737756.jpg";